'use client'

import type {PluginConfigComponent} from '@/plugins/sdk'
import {IframePluginView} from '@/plugins/IframePluginView'

export function getPluginConfigComponent(pluginId: string) {
    const ConfigView: PluginConfigComponent = (props) => <IframePluginView {...props} pluginId={pluginId}/>
    return ConfigView
}
